import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import * as home from './home';
import * as search from './search';
import * as user from './user';
import * as vi from './vi';
import * as category from './category';
import * as cart from './cart';
import * as pickup from './pickup';

const modules = {
    home,
    search,
    user,
    vi,
    category,
    cart,
    pickup
};


Vue.use(Vuex);
export default new Vuex.Store({
    strict: true, // 使用严格模式
    modules,
    plugins: [createPersistedState({ key: 'ylxdsq' })],
});